import React from "react";
import { UserProfilePopover } from "./UserProfile.styled";
import { UserProfilePopup } from "./UserProfilePopup/UserProfilePopup.component";

export const UserProfile: React.FC = React.memo(() => {
    return (
        <UserProfilePopover>
            <UserProfilePopup />
        </UserProfilePopover>
    );
});

UserProfile.displayName = "UserProfile";
